import { IProcessRequest } from "../../model/request/IProcessRequest";
import { IDanhSachMienGiamSelectByLopsRequest } from "../../model/request/mien-giam/IDanhSachMienGiamSelectByLopsRequest";
import { IDanhSachMienGiamTongTinChiRequest } from "../../model/request/mien-giam/IDanhSachMienGiamTongTinChiRequest";
import { apiClient } from "../apiClient";
import { INguoiKyBaoCao } from "../bao-cao/thietLapChuKyBaoCaoApi";
export const MIEN_GIAM_ENDPOINT = "mien-giam";

/** Một dòng gửi lên để xuất "Danh sách SV miễn giảm học phí" kèm đã nộp + thừa/thiếu. */
export interface IMienGiamXuatExcelItem {
  id_sv: string;
  id_lop: number;
  ma_sv: string;
  ho_ten: string;
  ngay_sinh?: string | Date | null;
  ten_lop: string;
  phan_tram: number;
  doi_tuong: string;
}

export interface IMienGiamXuatExcelRequest {
  hoc_ky: number;
  nam_hoc: string;
  sinh_viens: IMienGiamXuatExcelItem[];
  nguoi_kys: INguoiKyBaoCao[];
  /** Tên đơn vị + cơ quan chủ quản như phần mềm đang hiển thị — in ở đầu trang. */
  ten_don_vi?: string;
  co_quan_chu_quan?: string;
}
export const duyetMienGiamApi = {
  SelectAllByLop: (request: IDanhSachMienGiamSelectByLopsRequest) =>
    apiClient.post(`${MIEN_GIAM_ENDPOINT}/select-by-lops`, request),
  SelectTongTinChiBySinhViens: (
    request: IDanhSachMienGiamTongTinChiRequest,
  ) =>
    apiClient.post(
      `${MIEN_GIAM_ENDPOINT}/select-tong-tin-chi-by-svs`,
      request,
    ),
  XuatExcelDanhSach: (request: IMienGiamXuatExcelRequest) =>
    apiClient.post(`${MIEN_GIAM_ENDPOINT}/xuat-excel-danh-sach`, request),
  DuyetAsync: (request: IProcessRequest<number[]>) =>
    apiClient.put(
      `${MIEN_GIAM_ENDPOINT}/duyet?process_id=${request.process_id}`,
      request.payload
    ),
  HuyDuyetAsync: (request: IProcessRequest<number[]>) =>
    apiClient.put(
      `${MIEN_GIAM_ENDPOINT}/huy-duyet?process_id=${request.process_id}`,
      request.payload
    ),
};
